<template>
  <div>
    <el-row style="padding: 10px">
      <el-col :span="6" class="flex-items">
        <div class="flex-shrink" style="padding-right: 10px">学校名称：</div>
        <el-input placeholder="请输入内容" style="width: 200px"></el-input>
      </el-col>
      <el-col :span="6" class="flex-items">
        <div class="flex-shrink" style="padding-right: 10px">学段(年级)：</div>
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6" class="flex-center">
        <div class="flex-items">
          <div class="flex-shrink" style="padding-right: 10px">区县：</div>
          <el-select v-model="value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="flex-items">
          <el-col :span="4" class="flex-items" style="padding-left: 20px">
            <el-button type="primary">查询</el-button>
          </el-col>
        </div>
      </el-col>
    </el-row>

    <el-row style="padding: 0 0 10px 10px">
      <el-col>
        <button class="btn-add" @click="OclickAdd">添加</button>
      </el-col>
    </el-row>
    <el-row style="padding: 10px">
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :header-cell-style="{ background: '#F2F5FF', color: '#333' }"
      >
        <el-table-column align="center" type="selection" width="55">
        </el-table-column>
        <el-table-column
          align="center"
          prop="SchoolName"
          label="学校名称"
          width="180"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="AreaName"
          label="区域"
          width="180"
        >
        </el-table-column>
        <el-table-column align="center" prop="SchoolLogo" label="Logo">
          <template slot-scope="scope">
            <img :src="scope.row.SchoolLogo" width="60" height="60" alt="" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="SchoolCode"
          label="账号"
          width="180"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="SchoolType"
          label="类型"
          width="180"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="DayNum"
          label="合约剩余时间(天)"
          width="180"
        >
        </el-table-column>
        <el-table-column align="center" label="操作" width="300">
          <template scope="scope">
            <div class="flex" style="justify-content: space-around">
              <div class="tui-edit" @click="onClikcEdit(scope.row.Id)">
                编辑
              </div>
              <div>|</div>
              <div class="tui-delete" @click="Delete(scope.row.Id)">删除</div>
              <div class="tui-delete" @click="AddDayNum(scope.row.Id)">
                添加天数
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="10"
        :total="total"
        style="text-align: center;padding:20px; 0 0 0"
      >
      </el-pagination>
    </el-row>
    <!-- 添加 -->
    <el-dialog :visible.sync="dialogVisible" width="30%">
      <div>
        <el-row>
          <el-col
            style="
              background: #F2F5FF;
              height: 60px;
              justify-content: flex-start;
            "
            class="flex-center"
          >
            <div class="tui-row-add">添加/编辑</div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6" class="tui-border flex-center">
            <div>学校名称：</div>
          </el-col>
          <el-col :span="18" class="tui-input">
            <input v-model="addForm.SchoolName" type="text" />
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="tui-border flex-center">
            <div>管理员账号：</div>
          </el-col>
          <el-col :span="18" class="tui-input">
            <input v-model="addForm.ManageCode" type="text" />
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="tui-border flex-center">
            <div>管理员密码：</div>
          </el-col>
          <el-col :span="18" class="tui-input">
            <input v-model="addForm.PassWord" type="password" />
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="tui-border flex-center">
            <div>合约天数：</div>
          </el-col>
          <el-col :span="18" class="tui-input">
            <input v-model="addForm.DayNum" type="number" />
          </el-col>
        </el-row>
        <el-row>
          <el-col
            style="height: 130px"
            :span="6"
            class="tui-border flex-center"
          >
            <div>学校logo：</div>
          </el-col>
          <el-col style="height: 130px" :span="18" class="tui-input">
            <el-upload
              class="avatar-uploader"
              action="/api/Img/UploadImg"
              :show-file-list="false"
              width="110"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img
                referrer="no-referrer|origin|unsafe-url"
                v-if="imageUrl"
                :src="imageUrl"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="tui-border flex-center">
            <div>学校类型：</div>
          </el-col>
          <el-col :span="18">
            <el-select
              v-model="addForm.SchoolType"
              aria-required
              placeholder="请选择学校类型"
              style="width: 100%"
            >
              <el-option :key="0" :label="'初中'" :value="0" />
              <el-option :key="1" :label="'高中'" :value="1" />
              <el-option :key="2" :label="'小学'" :value="2" />
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="tui-border flex-center">
            <div>省份：</div>
          </el-col>
          <el-col :span="18">
            <el-select
              @change="prochange"
              v-model="provalue"
              placeholder="请选择省份"
              style="width: 100%"
            >
              <el-option
                v-for="item in pro"
                :key="item.Id"
                :label="item.Name"
                :value="item.Code"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6" class="tui-border flex-center">
            <div>城市：</div>
          </el-col>
          <el-col :span="18">
            <el-select
              @change="citychange"
              v-model="cityvalue"
              placeholder="请选择城市"
              style="width: 100%"
            >
              <el-option
                v-for="item in city"
                :key="item.Id"
                :label="item.Name"
                :value="item.Code"
              >
              </el-option>
            </el-select>
          </el-col>

          <el-col :span="6" class="tui-border flex-center">
            <div>区/县：</div>
          </el-col>
          <el-col :span="18">
            <el-select
              @change="areachange"
              v-model="areavalue"
              placeholder="请选择区/县"
              style="width: 100%"
            >
              <el-option
                v-for="item in area"
                :key="item.Id"
                :label="item.Name"
                :value="item.Code"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="SaveInfo">保存</el-button>
      </span>
    </el-dialog>
    <!-- 修改信息 -->
    <el-dialog :visible.sync="dialogVisibleupdate" width="30%">
      <el-row>
        <el-col
          style="background: #F2F5FF; height: 60px; justify-content: flex-start"
          class="flex-center"
        >
          <div class="tui-row-add">请输入新的学校信息</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6" class="tui-border flex-center">
          <div>学校名称：</div>
        </el-col>
        <el-col :span="18" class="tui-input">
          <input v-model="addForm.SchoolName" type="text" />
        </el-col>
      </el-row>
      <el-row>
        <el-col style="height: 120px" :span="6" class="tui-border flex-center">
          <div>学校logo：</div>
        </el-col>
        <el-col style="height: 120px" :span="18" class="tui-input">
          <el-upload
            class="avatar-uploader"
            action="/api/img/UploadImg"
            :show-file-list="false"
            width="110"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img
              referrer="no-referrer|origin|unsafe-url"
              v-if="imageUrl"
              :src="imageUrl"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6" class="tui-border flex-center">
          <div>省份：</div>
        </el-col>
        <el-col :span="18">
          <el-select
            @change="prochange"
            v-model="provalue"
            placeholder="请选择省份"
            style="width: 100%"
          >
            <el-option
              v-for="item in pro"
              :key="item.Id"
              :label="item.Name"
              :value="item.Code"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="tui-border flex-center">
          <div>城市：</div>
        </el-col>
        <el-col :span="18">
          <el-select
            @change="citychange"
            v-model="cityvalue"
            placeholder="请选择城市"
            style="width: 100%"
          >
            <el-option
              v-for="item in city"
              :key="item.Id"
              :label="item.Name"
              :value="item.Code"
            >
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="6" class="tui-border flex-center">
          <div>区/县：</div>
        </el-col>
        <el-col :span="18">
          <el-select
            @change="areachange"
            v-model="areavalue"
            placeholder="请选择区/县"
            style="width: 100%"
          >
            <el-option
              v-for="item in area"
              :key="item.Id"
              :label="item.Name"
              :value="item.Code"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleupdate = false">取 消</el-button>
        <el-button type="primary" @click="UpdateInfo">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleaddday" width="30%">
      <el-row>
        <el-col
          style="background: #F2F5FF; height: 60px; justify-content: flex-start"
          class="flex-center"
        >
          <div class="tui-row-add">请输入添加的天数</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6" class="tui-border flex-center">
          <div>添加天数：</div>
        </el-col>
        <el-col :span="18" class="tui-input">
          <input v-model="addForm.DayNum" type="text" />
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleaddday = false">取 消</el-button>
        <el-button type="primary" @click="AddDayInfo">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetRegionList,
  AddSchoolInfo,
  GetSchoolInfoByPage,
  GetSchoolInfoOne,
  DeleteSchoolInfo,
  UpdateSchoolInfo,
  AddDayNum,
} from "../../api/api";
export default {
  data() {
    return {
      imageUrl: "",
      //"http://oneevaluation.oss-cn-beijing.aliyuncs.com/images/2021-8/2021-8-2/20210802114133_9979.png",
      pro: [],
      provalue: "",
      city: [],
      cityvalue: "",
      area: [],
      areavalue: "",
      AreaCode: "",
      addForm: {
        Id: 0,
        SchoolType: "",
        IsOpen: 1,
        AreaId: 0,
        SchoolLogo: "",
        ShowName: "",
        SchoolName: "",
        ManageCode: "",
        PassWord: "",
        DayNum: 0,
      },
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      tableData: [],
      value: "",
      total: 0,
      dialogVisible: false,
      dialogVisibleupdate: false,
      dialogVisibleaddday: false,
    };
  },
  mounted() {
    //分页和搜索 没加  添加租约天数没加
    this.GetSchoolInfoByPage();
  },
  methods: {
    initform() {
      this.GetSchoolInfoByPage();
      this.addForm = {
        Id: 0,
        SchoolType: "",
        IsOpen: 1,
        AreaId: 0,
        SchoolLogo: "",
        ShowName: "",
        SchoolName: "",
        ManageCode: "",
        PassWord: "",
        DayNum: 0,
      };
    },
    AddDayInfo() {
      AddDayNum(this.addForm).then((res) => {
        if (res.data.success) {
          this.initform();
          this.dialogVisibleaddday = false;
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
            offset: 110,
          });
        }
      });
    },
    AddDayNum(id) {
      this.addForm.Id = id;
      this.dialogVisibleaddday = true;
    },
    UpdateInfo() {
      this.addForm.SchoolLogo = this.imageUrl;
      this.addForm.AreaId = this.AreaCode;
      UpdateSchoolInfo(this.addForm).then((res) => {
        if (res.data.success) {
          this.initform();
          this.dialogVisibleupdate = false;
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
            offset: 110,
          });
        }
      });
    },
    Delete(id) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      }).then(() => {
        DeleteSchoolInfo({ Ids: [id] }).then((res) => {
          if (res.data.success) {
            this.initform();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
              offset: 110,
            });
          }
        });
      });
    },
    onClikcEdit(id) {
      this.addForm.Id = id;
      this.GetRegionList();
      this.dialogVisibleupdate = true;
      GetSchoolInfoOne({ Id: id }).then((res) => {
        if (res.data.success) {
          this.addForm = res.data.response;
          this.imageUrl = res.data.response.SchoolLogo;
        }
      });
    },
    GetSchoolInfoByPage() {
      GetSchoolInfoByPage().then((res) => {
        if (res.data.success) {
          this.tableData = res.data.response.data;
        } else {
          this.tableData = [];
          this.$message({
            type: "error",
            message: res.data.msg,
            offset: 110,
          });
        }
      });
    },
    SaveInfo() {
      this.addForm.SchoolLogo = this.imageUrl;
      this.addForm.AreaId = this.AreaCode;
      AddSchoolInfo(this.addForm).then((res) => {
        if (res.data.success) {
          this.dialogVisible = false;
          this.initform();
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
            offset: 110,
          });
        }
      });
    },
    areachange(code) {
      this.AreaCode = code;
    },
    citychange(code) {
      this.areavalue = "";
      this.area = [];
      this.AreaCode = code;
      let para = { Code: code };
      GetRegionList(para).then((res) => {
        if (res.data.success) {
          this.area = res.data.response;
        }
      });
    },
    prochange(code) {
      this.cityvalue = "";
      this.area = [];
      this.areavalue = "";
      this.area = [];
      this.AreaCode = code;
      let para = { Code: code };
      GetRegionList(para).then((res) => {
        if (res.data.success) {
          this.city = res.data.response;
        }
      });
    },
    GetRegionList(code) {
      let para = { Code: code };
      GetRegionList(para).then((res) => {
        if (res.data.success) {
          this.pro = res.data.response;
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = res.response;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleCurrentChange(val) {},
    OclickAdd() {
      this.addForm = {
        Id: 0,
        SchoolType: "",
        IsOpen: 1,
        AreaId: 0,
        SchoolLogo: "",
        ShowName: "",
        SchoolName: "",
        ManageCode: "",
        PassWord: "",
        DayNum: 0,
      };
      this.GetRegionList();
      this.dialogVisible = true;
    },
  },
};
</script>
<style  lang="less" scoped>
.tui-input {
  height: 36px;
  background: #ffffff;
  border: 1px solid #eaeaea;
  // text-align: center;
  input {
    width: 200px;
    margin: 0 auto;
    border: none;
    height: 36px;
    // text-align: center;
  }
}
.tui-border {
  height: 36px;
  background: #ffffff;
  border: 1px solid #eaeaea;
  div {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }
}
.tui-row-add {
  padding: 0 0 0 20px;
  color: #333;
  font-size: 14px;
  font-weight: 500;
}
.tui-edit {
  color: #3d98ee;
  font-size: 14px;
}
.tui-delete {
  color: #f14545;
  font-size: 14px;
}
/deep/.el-table th > .cell {
  text-align: center;
}

/deep/.el-table .cell {
  text-align: center;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px !important;
  text-align: center;
}
</style>